import React from "react";
import "./ContactSec1.css";
import { Button, Card, Stack } from "react-bootstrap";
import { map } from "lodash";
import { IoMdArrowForward } from "react-icons/io";
import { Introduction } from "../../../Common/Introduction";

export const ContactSec1 = () => {
    const data = [
        { id: 1, img: "/assets/contact-icon1.png", title: "Email Our Team ", action: "mailto:holidays@Blueberrydmc.com", desc: "holidays@blueberrydmc.com" },
        { id: 2, img: "/assets/contact-icon2.png", title: "Speak to Our DMC Team ", action: "tel:+971559886749 ", desc: "+971 559 886749" },
{
  id: 3,
  img: "/assets/contact-icon3.png",
  title: "Chat With Us",
  action:
    "https://wa.me/+971559886749?text=Hello%20Blueberry%20DMC",
  desc: "+971 559 886749"
}
    ]
    return (
        <>
            <div className="contactsec1-content-main standard-padding " id="contact-sec1-id">
                <h3 className="heading mb-4" style={{ textAlign: "center" }}>How Travel Partners Can Reach Us </h3>
                <div className="contactsec1-content">
                    {map(data, d => (
                        <ContactDetails data={d} />
                    ))}
                </div>

            </div>
        </>
    )
}

const ContactDetails = ({ data }) => {
  return (
    <a
      href={data.action}
     className="contactsec1-card"
      target={data.action.includes("wa.me") ? "_blank" : "_self"}
      rel="noreferrer"
    >
        <Card.Img
          variant="top"
          className="contactsec1-card-image"
          src={data.img}
          alt="contact-image"
        />

        <Card.Body className="conatctCardBody">
          <Card.Text>{data.desc}</Card.Text>
          <Card.Title className="contactsec1-card-title">
            {data.title}
          </Card.Title>
        </Card.Body>
    </a>
  );
};